// extracted by mini-css-extract-plugin
export default {"description":"NoExperiencesModal_description__qReEl","boldText":"NoExperiencesModal_boldText__RjF6I","footer":"NoExperiencesModal_footer__ILMAZ"};